import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';

const projects = [
  {
    title: 'LA Activities Guide',
    description: 'A curated guide to the best things to do in LA',
    link: '/locals-only',
    status: 'live',
  },
  {
    title: 'Interactive Party Games',
    description: 'Arcade-style RSVP experiences for birthdays & events',
    link: '/games',
    status: 'live',
  },
  {
    title: 'Kinetic Typography',
    description: 'Motion design & type experiments',
    link: '/kinetic-typography',
    status: 'live',
  },
];

function Lab() {
  return (
    <motion.div
      className="lab-page"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.5 }}
    >
      <section style={{ padding: 'calc(70px + 3rem) clamp(2rem, 5vw, 6rem) 4rem', maxWidth: '900px', margin: '0 auto' }}>
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, ease: [0.16, 1, 0.3, 1] }}
        >
          <h1 style={{
            fontFamily: "'Playfair Display', Georgia, serif",
            fontSize: 'clamp(2rem, 5vw, 3rem)',
            fontWeight: 400,
            color: 'var(--color-text)',
            marginBottom: '0.5rem',
          }}>
            Lab
          </h1>
          <p style={{
            fontFamily: "'Inter', sans-serif",
            fontSize: '1rem',
            color: 'var(--color-text-muted)',
            marginBottom: '3rem',
            maxWidth: '500px',
          }}>
            Experiments & rabbit holes — things I build because I can't not.
          </p>
        </motion.div>

        <div style={{ display: 'flex', flexDirection: 'column', gap: '1px' }}>
          {projects.map((project, i) => (
            <motion.div
              key={project.title}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.2 + i * 0.08, ease: [0.16, 1, 0.3, 1] }}
            >
              <Link
                to={project.link}
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  padding: '1.5rem 0',
                  textDecoration: 'none',
                  borderBottom: '1px solid rgba(45, 42, 38, 0.1)',
                  transition: 'padding-left 0.3s ease',
                }}
                onMouseEnter={(e) => { e.currentTarget.style.paddingLeft = '8px'; }}
                onMouseLeave={(e) => { e.currentTarget.style.paddingLeft = '0'; }}
              >
                <div>
                  <h2 style={{
                    fontFamily: "'Playfair Display', Georgia, serif",
                    fontSize: '1.25rem',
                    fontWeight: 400,
                    color: 'var(--color-text)',
                    marginBottom: '4px',
                  }}>
                    {project.title}
                  </h2>
                  <p style={{
                    fontFamily: "'Inter', sans-serif",
                    fontSize: '0.85rem',
                    color: 'var(--color-text-muted)',
                  }}>
                    {project.description}
                  </p>
                </div>
                <span style={{ color: 'var(--color-text-dim)', fontSize: '1.25rem' }}>&rarr;</span>
              </Link>
            </motion.div>
          ))}
        </div>
      </section>
    </motion.div>
  );
}

export default Lab;
